import { useClientStore } from '@/client/stores/client';

/**
 * Decrypted bytes of an encrypted asset (claim evidence, KYC). `request()` reads bodies as
 * text, which corrupts PDFs/images, so this fetches a Blob; the proxy streams it through.
 */
export async function fetchSecureAssetBlob(uuid: string): Promise<Blob> {
  const res = await fetch(`/api/v2/secure-asset/${encodeURIComponent(uuid)}`, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
    headers: (useClientStore.getState().defaultHeaders ?? {}) as Record<string, string>,
  });
  if (!res.ok) {
    const err = new Error(
      res.status === 403
        ? "You don't have access to this file."
        : res.status === 404
          ? 'This file is no longer available.'
          : `Could not load the file (${res.status}).`,
    ) as Error & { status?: number };
    err.status = res.status;
    throw err;
  }
  return res.blob();
}
